import { Flame } from 'lucide-react';
import React, { useContext } from 'react';

import { trackMixpanelEvent } from 'utils/integrations/mixpanel';
import {
  MixpanelAction,
  MixpanelObject
} from 'utils/integrations/mixpanel/constants';

import UserContext from 'components/UserContext';

const EMBER_CHATBOT_ENABLED =
  process.env.REACT_APP_STUDENT_EMBER_CHATBOT_ENABLED === 'true';

const EmberButton = ({
  isMathAssignment,
  isEmberHidden,
  style = {},
  onClick
}) => {
  const user = useContext(UserContext);

  const isButtonActive =
    isMathAssignment && isEmberHidden && !EMBER_CHATBOT_ENABLED;

  const containerStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '10px',
    height: '50px'
  };

  const defaultStyle = {
    width: 'auto',
    padding: '10px 18px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    border: 'none',
    borderRadius: '9999px',
    background: 'linear-gradient(90deg, #6A11CB 0%, #FF4B2B 100%)',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 600,
    zIndex: 1000,
    bottom: '85px',
    right: '16px',
    cursor: 'pointer',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
  };

  const handleClick = () => {
    trackMixpanelEvent(
      user.id,
      `${MixpanelObject.BUTTON} ${MixpanelAction.CLICK}`,
      {
        feature: 'pathways',
        view: 'ember',
        button: 'open'
      }
    );
    onClick?.();
  };

  return (
    <div style={containerStyle}>
      {isButtonActive && (
        <button style={{ ...defaultStyle, ...style }} onClick={handleClick}>
          <Flame size={18} fill="white" stroke="white" />
          Ember Tip
        </button>
      )}
    </div>
  );
};

export default EmberButton;
